var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(" ACTIONS ")]),_c('cbs-objects-tbl',{attrs:{"prop-filter":"actions"}}),_c('div',[_c('p',[_vm._v("session: "+_vm._s(_vm.session))]),_c('p',[_vm._v("object: "+_vm._s(_vm.object))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }